module.exports = __webpack_public_path__ + "img/32.d8674be6.jpg";